import { ActionType, IAction } from "../shared/interfaces/Action";

import {
	TokenRequest,
	BaseTokenRequestHandler,
	GRANT_TYPE_AUTHORIZATION_CODE,
	AuthorizationRequest,
	AuthorizationServiceConfiguration,
	RedirectRequestHandler,
	AuthorizationNotifier,
	FetchRequestor,
	LocalStorageBackend,
	DefaultCrypto,
  GRANT_TYPE_REFRESH_TOKEN,
} from "@openid/appauth";
import { NoHashQueryStringUtils } from "../shared/helpers/NoHashQueryStringUtils";
import { OIDCConfig } from "../shared/config/OIDCConfig";

const fetchAccessTokenSuccess = (data: any): IAction => {
	return {
		type: ActionType.FETCH_ACCESS_TOKEN_SUCCESS,
		payload: data,
	};
};

const fetchAccessTokenFailure = (payload: any): IAction => {
	return {
		type: ActionType.FETCH_ACCESS_TOKEN_FAILURE,
		payload,
	};
};

export const fetchToken = () => {
	const authorizationHandler = new RedirectRequestHandler(
		new LocalStorageBackend(),
		new NoHashQueryStringUtils(),
		window.location,
		new DefaultCrypto()
	);
	AuthorizationServiceConfiguration.fetchFromIssuer(
		OIDCConfig.authority,
		new FetchRequestor()
	).then((response) => {
		const authRequest = new AuthorizationRequest({
			client_id: OIDCConfig.client_id,
			redirect_uri: OIDCConfig.redirect_uri,
			scope: OIDCConfig.scope,
			response_type: OIDCConfig.response_type,
		});
		authorizationHandler.performAuthorizationRequest(response, authRequest);
	})
}

export const fetchAccessToken = (code: string) => {
const authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(), new NoHashQueryStringUtils(), window.location, new DefaultCrypto());

const notifier = new AuthorizationNotifier();
        authorizationHandler.setAuthorizationNotifier(notifier);

const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
notifier.setAuthorizationListener((request, response, error) => {
	if (response) {
		let tokenRequest: TokenRequest;
		if (response.code) {
			let extras: any;
			if (request && request.internal) {
				extras = { code_verifier: "" };
				extras.code_verifier = request.internal.code_verifier;
			}
			extras.userInfo = true;

			tokenRequest = new TokenRequest({
				client_id: OIDCConfig.client_id,
				redirect_uri: OIDCConfig.redirect_uri,
				grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
				code: response.code,
				refresh_token: undefined,
				extras: extras,
			});
		}
		AuthorizationServiceConfiguration.fetchFromIssuer(
			OIDCConfig.authority,
			new FetchRequestor()
		).then((oResponse) => {
			tokenHandler
				.performTokenRequest(oResponse, tokenRequest)
				.then((tokenResponse) => {
					const accessToken = tokenResponse.accessToken;
					const refreshToken = tokenResponse.refreshToken;
					localStorage.setItem("access_token", accessToken);
					localStorage.setItem(
						"refresh_token",
						refreshToken || ""
					);
					var thirtyMinutesLater = new Date();
					thirtyMinutesLater.setMinutes(thirtyMinutesLater.getMinutes() + 30);
					localStorage.setItem("accesstoken_expiry",thirtyMinutesLater.toString());
					fetchAccessTokenSuccess(response);
					const uri = window.location.toString();
					const originURL = window.location.origin;
					if (uri.indexOf("?") > 0) {
						const clean_uri = uri.substring(
							0,
							uri.indexOf("?")
						);
						window.history.replaceState(
							{},
							document.title,
							clean_uri
						);
						window.location.href = originURL;
					}
				})
				.catch((oError) => {
					fetchAccessTokenFailure(oError);
					localStorage.clear();
					const originURL = window.location.origin;
					window.location.href = originURL;
				});
		});
		authorizationHandler.completeAuthorizationRequestIfPossible();
	}
});
authorizationHandler.completeAuthorizationRequestIfPossible()
};


export const refreshAccessToken = async () => {

	const refreshToken = localStorage.getItem("refresh_token");
	if (!refreshToken) throw new Error("No refresh token available");

	try {
		// Fetch the issuer configuration
		const config = await AuthorizationServiceConfiguration.fetchFromIssuer(
			OIDCConfig.authority,
			new FetchRequestor()
		);

		// Create the token request
		const tokenRequest = new TokenRequest({
			client_id: OIDCConfig.client_id,
			redirect_uri: OIDCConfig.redirect_uri,
			grant_type: GRANT_TYPE_REFRESH_TOKEN,
			refresh_token: refreshToken,
			extras: { scope: OIDCConfig.scope },
		});

		// Send the token request
		const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
		const tokenResponse = await tokenHandler.performTokenRequest(config, tokenRequest);

		// Store the new tokens
		localStorage.setItem("access_token", tokenResponse.accessToken);
		localStorage.setItem("refresh_token", tokenResponse.refreshToken || "");
		var thirtyMinutesLater = new Date();
		thirtyMinutesLater.setMinutes(thirtyMinutesLater.getMinutes() + 30);
		localStorage.setItem("accesstoken_expiry", thirtyMinutesLater.toString());
		return fetchAccessTokenSuccess(tokenResponse);
	} catch (error) {
		return fetchAccessTokenFailure(error);
	}
};

const fetchIssuerRequest = (): IAction => {
	return {
		type: ActionType.FETCH_ISSUER_REQUEST,
	};
};

export const fetchIssuerDetails = () => {
	const authorizationHandler = new RedirectRequestHandler(
		new LocalStorageBackend(),
		new NoHashQueryStringUtils(),
		window.location,
		new DefaultCrypto()
	);

	return (dispatch: any) => {
		dispatch(fetchIssuerRequest());
		return AuthorizationServiceConfiguration.fetchFromIssuer(
			OIDCConfig.authority,
			new FetchRequestor()
		)
			.then((response) => {
				const authRequest = new AuthorizationRequest({
					client_id: OIDCConfig.client_id,
					redirect_uri: OIDCConfig.redirect_uri,
					scope: OIDCConfig.scope,
					response_type: OIDCConfig.response_type,
					state: undefined,
					// extras: environment.extra
				});
				authorizationHandler.performAuthorizationRequest(
					response,
					authRequest
				);
			})
			.catch((error) => {
				//setError(error);
			});
	};
};